export default "__VITE_ASSET__DdsVj3k1__"